/**
 * The sentence under the "Decks" title: "62 decks · 12 published · 50 drafts".
 *
 * It describes the WHOLE collection and never the filtered subset. That is the
 * point of the split: this line is the standing fact about what the studio
 * holds, and "how many of them am I looking at right now" is the chip row's
 * job ("Showing 12 of 62"). One number that quietly changed meaning depending
 * on whether a filter was on would make both of them untrustworthy.
 *
 * Pure so it can be asserted on directly — the pluralisation is the sort of
 * thing that reads fine until the day somebody has exactly one deck.
 */

export type DeckCounts = {
  /** Every deck the dashboard would show with no filter (banks excluded). */
  total: number;
  published: number;
  drafts: number;
};

/** "1 deck", "62 decks" — the count and its noun, agreeing. */
function plural(n: number, one: string, many: string): string {
  return `${n} ${n === 1 ? one : many}`;
}

/**
 * Build the muted counts line. "published" needs no plural — it is an
 * adjective standing in for "published decks" — but "deck" and "draft" do.
 */
export function deckCountsLine({ total, published, drafts }: DeckCounts): string {
  return `${plural(total, 'deck', 'decks')} · ${published} published · ${plural(drafts, 'draft', 'drafts')}`;
}
